import { render, staticRenderFns } from "./DefaultSidenav.vue?vue&type=template&id=246c3a08"
import script from "./DefaultSidenav.vue?vue&type=script&lang=js"
export * from "./DefaultSidenav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports